// productActions.js - Corrected version
import { productAPI } from './api';
import Swal from 'sweetalert2';

export const productActions = {
  // Get products list (simple async function, not Redux thunk)
  getProducts: async (params = {}) => {
    try {
      const response = await productAPI.list(params);
      console.log('Products API response:', response);

      if (response.success) {
        return {
          success: true,
          data: response.data?.products || response.data || [],
          total: response.data?.total || 0,
          page: response.data?.page || 1,
          totalPages: response.data?.total_pages || 1
        };
      } else if (response.data) {
        return {
          success: true,
          data: response.data.products || response.data || [],
          total: response.data.total || 0,
          page: response.data.page || 1,
          totalPages: response.data.total_pages || 1
        };
      }

      return {
        success: false,
        message: response?.message || 'Failed to fetch products',
        data: []
      };
    } catch (error) {
      console.error('Error fetching products:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch products',
        data: []
      };
    }
  },

  // Search products for dropdown/autocomplete
 searchProducts: async (searchTerm) => {
    try {
      // Remove the limit parameter completely
      const response = await productAPI.search(searchTerm);
      console.log('Product search response:', response);

      if (response.success) {
        return {
          success: true,
          data: response.data || []
        };
      }

      return {
        success: false,
        message: response?.message || 'Failed to search products',
        data: []
      };
    } catch (error) {
      console.error('Error searching products:', error);
      return {
        success: false,
        message: error.message || 'Failed to search products',
        data: []
      };
    }
  },
  getCategories: async () => {
    try {
      const response = await productAPI.getCategories();
      console.log('Categories API response:', response);

      if (response && (response.success || response.data)) {
        return {
          success: true,
          data: response.data || response
        };
      }
      return {
        success: false,
        message: response?.message || 'Failed to fetch categories',
        data: []
      };
    } catch (error) {
      console.error('Error fetching categories:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch categories',
        data: []
      };
    }
  },

  getBrands: async () => {
    try {
      const response = await productAPI.getBrands();
      console.log('Brands API response:', response);

      if (response && (response.success || response.data)) {
        return {
          success: true,
          data: response.data || response
        };
      }
      return {
        success: false,
        message: response?.message || 'Failed to fetch brands',
        data: []
      };
    } catch (error) {
      console.error('Error fetching brands:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch brands',
        data: []
      };
    }
  },

  getUnits: async () => {
    try {
      const response = await productAPI.getUnits();
      if (response && (response.success || response.data)) {
        return {
          success: true,
          data: response.data || response
        };
      }
      return {
        success: false,
        message: response?.message || 'Failed to fetch units',
        data: []
      };
    } catch (error) {
      console.error('Error fetching units:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch units',
        data: []
      };
    }
  },

  // Redux thunk actions
  fetchProducts: (params = {}) => {
    return async (dispatch) => {
      try {
        console.log('Fetching products with params:', params);

        const response = await productAPI.list(params);
        console.log('API Response:', response);

        if (response.success) {
          console.log('Products fetched:', response.data.products?.length || 0);

          dispatch({
            type: "Product_list",
            payload: response.data.products || []
          });

          return {
            success: true,
            data: response.data,
            pagination: response.data.pagination
          };
        } else {
          console.error('API returned false status:', response.message);
          throw new Error(response.message || 'Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);

        if (!params.silent) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Failed to fetch products',
            confirmButtonColor: '#ff0000'
          });
        }

        return {
          success: false,
          message: error.message || 'Failed to fetch products'
        };
      }
    };
  },

  fetchProductById: (id) => {
    return async (dispatch) => {
      try {
        const response = await productAPI.getSingle(id);
        debugger;
        if (response.success) {
          dispatch({
            type: "Selected_Product",
            payload: response.data
          });

          return {
            success: true,
            data: response
          };
        } else {
          throw new Error(response.message || 'Failed to fetch product');
        }
      } catch (error) {
        console.error('Error fetching product by ID:', error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Failed to fetch product details',
          confirmButtonColor: '#ff0000'
        });

        return {
          success: false,
          message: error.message || 'Failed to fetch product'
        };
      }
    };
  },

  addProductList: (productData) => {
    return async () => {
      try {
        const response = await productAPI.create(productData);

        if (response.success) {
          return {
            success: true,
            data: response.data,
            message: response.message || 'Product added successfully'
          };
        } else {
          throw new Error(response.message || 'Failed to add product');
        }
      } catch (error) {
        console.error('Error adding product:', error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Failed to add product',
          confirmButtonColor: '#ff0000'
        });

        return {
          success: false,
          message: error.message || 'Failed to add product'
        };
      }
    };
  },

  updateProduct: (id, productData) => {
    return async (dispatch) => {
      try {
        const response = await productAPI.update(id, productData);

        if (response.success) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Product updated successfully',
            confirmButtonColor: '#00ff00'
          });

          dispatch(productActions.fetchProducts());

          return {
            success: true,
            data: response.data
          };
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error('Error updating product:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: error.message || 'Failed to update product',
          confirmButtonColor: '#ff0000'
        });
        return {
          success: false,
          message: error.message || 'Failed to update product'
        };
      }
    };
  },

  deleteProduct: (id) => {
    return async (dispatch) => {
      try {
        const response = await productAPI.delete(id);

        if (response.status) {
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Product deleted successfully',
            confirmButtonColor: '#00ff00'
          });

          dispatch(productActions.fetchProducts());

          return {
            success: true
          };
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error('Error deleting product:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: error.message || 'Failed to delete product',
          confirmButtonColor: '#ff0000'
        });
        return {
          success: false,
          message: error.message || 'Failed to delete product'
        };
      }
    };
  },

  checkSkuExists: async (sku) => {
    try {
      const response = await productAPI.checkSku(sku);

      if (response.status) {
        return response.data.products && response.data.products.length > 0;
      }
      return false;
    } catch (error) {
      console.error('Error checking SKU:', error);
      return false;
    }
  },

  checkItemCodeExists: async (itemCode) => {
    try {
      const response = await productAPI.checkItemCode(itemCode);

      if (response.status) {
        return response.data.products && response.data.products.length > 0;
      }
      return false;
    } catch (error) {
      console.error('Error checking item code:', error);
      return false;
    }
  },

  // FIXED: getMasterData - Properly extract data from API response
  getMasterData: () => {
    return async () => {
      try {
        const [categories, brands, units] = await Promise.all([
          productAPI.getCategories(),
          productAPI.getBrands(),
          productAPI.getUnits()
        ]);

        console.log('Categories response:', categories);
        console.log('Brands response:', brands);
        console.log('Units response:', units);

        // Helper function to extract array from API response
        const extractArray = (response) => {
          // If response is null or undefined
          if (!response) return [];

          // If response has success and data
          if (response.success && response.data) {
            // Check if data is an array
            if (Array.isArray(response.data)) return response.data;
            // Check if data has categories/brands/units property
            if (response.data.categories) return response.data.categories;
            if (response.data.brands) return response.data.brands;
            if (response.data.units) return response.data.units;
          }

          // If response itself is the data array
          if (Array.isArray(response)) return response;

          // If response has data that's an array
          if (response.data && Array.isArray(response.data)) return response.data;

          // If response has categories/brands/units at root
          if (response.categories) return response.categories;
          if (response.brands) return response.brands;
          if (response.units) return response.units;

          // Return empty array as fallback
          return [];
        };

        const categoriesArray = extractArray(categories);
        const brandsArray = extractArray(brands);
        const unitsArray = extractArray(units);

        console.log('Extracted categories:', categoriesArray);
        console.log('Extracted brands:', brandsArray);
        console.log('Extracted units:', unitsArray);

        return {
          success: true,
          data: {
            categories: categoriesArray,
            brands: brandsArray,
            units: unitsArray
          }
        };
      } catch (error) {
        console.error('Error fetching master data:', error);
        return {
          success: false,
          message: error.message || 'Failed to fetch master data',
          data: {
            categories: [],
            brands: [],
            units: []
          }
        };
      }
    };
  },
  // Get last sale price for a customer-product combination
  getLastPrice: async (customerId, productId) => {
    try {
      if (!customerId || !productId) {
        return { success: true, data: null };
      }

      const response = await productAPI.getLastPrice(customerId, productId);

      if (response && response.success) {
        return {
          success: true,
          data: response.data,
          message: response.message
        };
      }

      return {
        success: true,
        data: null,
        message: 'No previous price found'
      };
    } catch (error) {
      console.error('Error fetching last price:', error);
      return {
        success: false,
        data: null,
        message: error.message || 'Failed to fetch last price'
      };
    }
  },


  clearProductDetails: () => {
    return {
      type: "CLEAR_PRODUCT_DETAILS"
    };
  }
};